import { render } from "./Web3Modal.vue?vue&type=template&id=1dba8519"
import script from "./Web3Modal.vue?vue&type=script&lang=js"
export * from "./Web3Modal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__